// extracted by mini-css-extract-plugin
export default {"container":"MediaStep_container__lvfUI","header":"MediaStep_header__Q6gqv","icon":"MediaStep_icon__TcCAj","text":"MediaStep_text__Mi7wl","content":"MediaStep_content__Q0Vam"};